<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-7">
<h1>Chapter 7</h1>
<p>The night’s calmness and stillness were shattered by the throaty growl of the twin exhaust pipes of the high-performance V12 engine, pushing the late model Ferrari along the lonely road that hardly ever saw traffic, let alone a beast like this driven at its optimum working load. It hugged the sharp corners gracefully, much like a water spider manoeuvres itself over the surface of the water.</p>
<p>Naomi was behind the wheel after Mitch had just fallen into a drug-induced coma, compliments of the dark side of this very complex woman. It had finally resurfaced to take charge of the situation by slipping some meds into his meal at the diner.</p>
<p>A smile ran over her face as she looked at her comatose passenger and one-time lover. Somehow, she had retained a tiny bit of compassion. He will never understand what could have happened to him on this remote route, and how close he came to being another murdered victim of this ruthless killer.</p>
<p>He will be spared an unpleasant death; he was not in her sights. But she cannot fulfil her destiny riding shotgun with an ex-law officer. He will be dropped off in a fully paid-for motel, paid in cash of course, with the compulsory fake ID so no breadcrumbs are left behind for law officers.</p>
<p>This will give her ample time to get as much distance between them before he wakes up. He will more than likely be confused and disappointed in how the promising romance ended so abruptly and without explanation. “Relationships always end badly, or they would not end,” she contemplated sadly, after laying him down in the motel bed.</p>
<p>The Night Watchwoman knows that this is breaking protocol, letting him live, if she was abiding by the textbook serial killer manual. <em>But just maybe? She had a tiny bit of empathy left in her from her days as a caring human being, before her world had become very dark and brutal,</em> she thought to herself.</p>
<p>The blood-red Ferrari thundered its way loudly along the Pacific Hwy, easily cruising at 110 km/h, with Naomi directing its long red nose northeast towards the picturesque coastline.</p>
<p>The first stop was Surfers Paradise on the Gold Coast for Naomi to find a pad and instigate her new plan to rid the Gold Coast of the garbage that permeates this once-family-orientated tourist destination.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?25d8fcf8